module.exports = __webpack_public_path__ + "img/Leo_minor.ff1ae757.png";